import { createFileRoute } from '@tanstack/react-router'
import { AggregationDetailPage } from '../../../components/AggregationDetailPage'

export const Route = createFileRoute('/$org/aggregations/$uid')({
  component: () => <AggregationDetailPage />,
})
